import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import LoadingPage from "@components/modules/loading/LoadingPage";
import { useAuth } from "../../context/AuthContext";

interface ProtectedRouteProps {
  children: ReactNode;
}
export default function RootProtectedRoute({ children }: ProtectedRouteProps) {
  const { session, loading } = useAuth();

  if (loading) return <LoadingPage />;
  if (!session) return <Navigate to="/" />;

  return children;
}
